import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pulse-disclaimer',
  templateUrl: './disclaimer.component.html',
})
export class DisclaimerComponent implements OnInit {
  @Input() text: string;
  @Input() icon: string;
  constructor() {}

  ngOnInit(): void {}
}
